import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, PRECIO_LARGO } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 700;
      const target = document.getElementById('comprar');
      const nearOffer = target ? target.getBoundingClientRect().top < window.innerHeight : false;
      setVisible(past && !nearOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-navy/10 bg-white/95 px-4 pb-[env(safe-area-inset-bottom)] backdrop-blur transition-transform duration-200 ease-out lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-154" data-mp="3gk5o9fnalwj4">
      <div className="flex items-center gap-3 py-3" data-id="element-155" data-mp="gyimmayk2iqv">
        <div className="shrink-0" data-id="element-156" data-mp="75vsvfe1qtat">
          <p className="font-mono text-base font-bold leading-none text-navy" data-id="element-157" data-mp="76xf8g0ij27u">{PRECIO_LARGO}</p>
          <p className="mt-1 text-[11px] leading-none text-navy-muted" data-id="element-158" data-mp="27u88q0z2lx8">Acceso inmediato</p>
        </div>
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="flex-1 rounded-lg bg-celeste-deep px-4 py-3.5 text-center font-display text-sm font-bold uppercase tracking-tight text-white transition-colors duration-150 ease-out hover:bg-celeste-deeper" data-id="element-159" data-mp="gwqo3999t38e">
          Limpiar mi historial
        </a>
      </div>
    </div>;
}